var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2256",
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2260"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2270"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path2268"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2262",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2266",
    clipPath: "url(#clipPath2270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 386.763,62.04 H 342.534 V 504.5 h 44.229 z",
    style: {
      fill: "none",
      stroke: "#019df2",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2272"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2274",
    transform: "translate(118.5068,504.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -22.057 C -32.275,0 -40.56,-8.284 -40.56,-18.502 v -405.456 c 0,-10.219 8.285,-18.502 18.503,-18.502 l 22.057,0 z",
    style: {
      fill: "none",
      stroke: "#019df2",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "124, 35, 480, 0",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "path2276"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2278",
    transform: "translate(118.5068,62.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -51.65 c 0,-2.504 2.972,-3.819 4.825,-2.134 l 24.964,22.695 c 1.101,1 2.78,1 3.881,0 l 24.964,-22.695 c 1.853,-1.685 4.824,-0.37 4.824,2.134 l 0,51.65 z",
    style: {
      fill: "none",
      stroke: "#019df2",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2280"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2282",
    transform: "translate(342.5342,443.1069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -147.02 c -4.248,0 -7.692,-3.444 -7.692,-7.692 v -50.959 c 0,-4.248 3.444,-7.691 7.692,-7.691 H 0 Z",
    style: {
      fill: "none",
      stroke: "#019df2",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2284"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2286",
    transform: "translate(395.1006,504.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -276.594 V -442.46 H 0 c 21.513,0 38.952,17.439 38.952,38.952 V -38.952 C 38.952,-17.439 21.513,0 0,0 Z",
    style: {
      fill: "none",
      stroke: "#019df2",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "871, 35, 768, 0",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "path2288"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBook);
export default __webpack_public_path__ + "static/media/menu-book.14d9881a066997ecfd408e430ea44819.svg";
export { ForwardRef as ReactComponent };